'use es6';

import { GRID_NODE_TYPES } from 'layout-data-lib/GridLayoutDataTree/constants';
const prepareNewGridModuleData = newModuleSchemaJson => {
  if (newModuleSchemaJson) {
    var _newModuleData$path;
    const newModuleData = Object.assign({}, newModuleSchemaJson);
    newModuleData.jsModule = newModuleData.body.isJsModule;
    newModuleData.moduleId = newModuleData.module_id;
    newModuleData.path = (_newModuleData$path = newModuleData.path) !== null && _newModuleData$path !== void 0 ? _newModuleData$path : newModuleData.body.path;
    newModuleData.type = GRID_NODE_TYPES.MODULE;
    newModuleData.styles = {};
    delete newModuleData.module_id;
    delete newModuleData.body;
    return newModuleData;
  }
  return null;
};
export const prepareNewGridModuleDataHelper = newModuleSchemaJson => {
  return prepareNewGridModuleData(newModuleSchemaJson);
};